import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';
import {  of } from 'rxjs';

import * as EventActions from './event.actions';
import { EventService } from '../services/event.service';
import { Router } from '@angular/router';
import { LoadingService } from 'app/core/services/loading.service';


@Injectable()
export class EventEffects {

  
  loadEventList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.loadEventList),
      exhaustMap((action: any) => {
        return this.eventService.getAllEvents().pipe(
          map(data => EventActions.loadEventListSuccess({ data })),
          catchError(error => of(EventActions.loadEventListFailure({ error }))))
      })
    );
  });

  loadEventListAndSelect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.loadEventListAndSelect),
      exhaustMap(({ payload }) => {
        return this.eventService.getAllEvents().pipe(
          map((data: any[]) => {
            const event = data.find(event => {
              switch(event.type) {
                case 0: {
                  if(event.inPersonEventInfo.id === payload) return true;
                  break;
                }
                case 1: {
                  if(event.virtualEventInfo.id === payload) return true;
                  break;
                }
                case 2: {
                  if(event.hybridEventInfo.id === payload) return true;
                  break;
                }
              }
              return false;
            });
            return EventActions.selectEvent({ payload: event });
          }),
          catchError(error => of(EventActions.loadEventListAndSelectFailure({ error }))))
      })
    );
  });

  createEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.createEvent),
      exhaustMap(({ payload, redirect }: any) => {
        return this.eventService.createEvent(payload).pipe(
          map(data => {
            return EventActions.createEventSuccess({ data, redirect });
            
          }),
          catchError(error => of(EventActions.createEventFailure({ error }))))
      })
    );
  });

  createEventSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.createEventSuccess),
      map(({ redirect }: any) => {
        if(redirect) {
          return EventActions.EventRedirectToListAction({});
        }
        return EventActions.EventEmptyAction({});
      })
    );
  });

  createVEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.createVEvent),
      exhaustMap(({ payload, redirect }: any) => {
        return this.eventService.createVEvent(payload).pipe(
          map(data => {
            return EventActions.createVEventSuccess({ data, redirect });
          }),
          catchError(error => of(EventActions.createEventFailure({ error }))))
      })
    );
  });

  createVEventSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.createVEventSuccess),
      map(({ redirect }: any) => {
        if(redirect) {
          return EventActions.EventRedirectToListAction({});;
        }
        return EventActions.EventEmptyAction({});
      })
    );
  });

  createHEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.createHEvent),
      exhaustMap(({ payload, redirect }: any) => {
        return this.eventService.createHEvent(payload).pipe(
          map(data => {
            return EventActions.createHEventSuccess({ data, redirect });
          }),
          catchError(error => of(EventActions.createHEventFailure({ error }))))
      })
    );
  });

  createHEventSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.createHEventSuccess),
      map(({ redirect }: any) => {
        if(redirect) {
          return EventActions.EventRedirectToListAction({});;
        }
        return EventActions.EventEmptyAction({});
      })
    );
  });

  putEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.putEvent),
      exhaustMap(({ payload, redirect }: any) => {
        return this.eventService.updateEvent(payload).pipe(
          map(data => {
            if(redirect) {
              return EventActions.EventRedirectToListAction({});;
            }
            return EventActions.putEventSuccess({ data });
          }),
          catchError(error => of(EventActions.putEventFailure({ error }))))
      })
    );
  });

  putEventSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.putEventSuccess),
      map(({ redirect }: any) => {
        if(redirect) {
          return EventActions.EventRedirectToListAction({});;
        }
        return EventActions.EventEmptyAction({});
      })
    );
  });

  putVEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.putVEvent),
      exhaustMap(({ payload, redirect }: any) => {
        return this.eventService.updateVEvent(payload).pipe(
          map(data => {
            if(redirect) {
              return EventActions.putEventSuccess({ data: { id: null },redirect });
            }
            return EventActions.putEventSuccess({ data });
          }),
          catchError(error => of(EventActions.putEventFailure({ error }))))
      })
    );
  });

  putVEventSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.putVEventSuccess),
      map(({ redirect }: any) => {
        if(redirect) {
          return EventActions.EventRedirectToListAction({});;
        }
        return EventActions.EventEmptyAction({});
      })
    );
  });

  putHEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.putHEvent),
      exhaustMap(({ payload, redirect }: any) => {
        return this.eventService.updateHEvent(payload).pipe(
          map(data => {
            if(redirect) {
              return EventActions.putEventSuccess({ data: { id: null }, redirect });
            }
            return EventActions.putEventSuccess({ data });
          }),
          catchError(error => of(EventActions.putEventFailure({ error }))))
      })
    );
  });

  putHEventSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.putHEventSuccess),
      map(({ redirect }: any) => {
        if(redirect) {
          return EventActions.EventRedirectToListAction({});;
        }
        return EventActions.EventEmptyAction({});
      })
    );
  });

  deleteEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.deleteEvent),
      exhaustMap(({ payload }) => {
        return this.eventService.deleteEvent(payload.id).pipe(
          map(data => EventActions.deleteEventSuccess({ payload, data })),
          catchError(error => of(EventActions.deleteEventFailure({ error }))))
      })
    );
  });

  deleteVEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.deleteVEvent),
      exhaustMap(({ payload }) => {
        return this.eventService.deleteVEvent(payload.id, payload.deleteValue).pipe(
          map(data => EventActions.deleteVEventSuccess({ payload, data })),
          catchError(error => of(EventActions.deleteVEventFailure({ error }))))
      })
    );
  });

  deleteHEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.deleteHEvent),
      exhaustMap(({ payload }) => {
        return this.eventService.deleteHEvent(payload.id, payload.deleteValue).pipe(
          map(data => EventActions.deleteHEventSuccess({ payload, data })),
          catchError(error => of(EventActions.deleteHEventFailure({ error }))))
      })
    );
  });

  resetVEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.resetVEvent),
      exhaustMap(({ payload }) => {
        return this.eventService.resetVEvent(payload).pipe(
          map(data => EventActions.resetVEventSuccess({ payload, data })),
          catchError(error => of(EventActions.resetVEventFailure({ error }))))
      })
    );
  });

  loadEventConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.loadEventConfig),
      switchMap(({ payload }) => {
        this.loadingService.transform = false;
        return this.eventService.getEventConfig(payload).pipe(
          map(data => {
            this.loadingService.transform = true;
            return EventActions.loadEventConfigSuccess({ data });
          }),
          catchError(error => {
            this.loadingService.transform = true;
            return of(EventActions.loadEventConfigFailure({ error }));
          }));
      })
    );
  });

  addEventPageBlock$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.addEventPageBlock),
      exhaustMap(({ payload }) => {
        return this.eventService.addEventPageBlock(payload).pipe(
          map(data => {
            return EventActions.addEventPageBlockSuccess({ data });
          }),
          catchError(error => {
            return of(EventActions.addEventPageBlockFailure({ error }));
          }));
      })
    );
  });

  updateEventPageBlock$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.updateEventPageBlock),
      exhaustMap(({ payload }) => {
        return this.eventService.updateEventPageBlock(payload).pipe(
          map(data => {
            return EventActions.updateEventPageBlockSuccess({ data });
          }),
          catchError(error => {
            return of(EventActions.updateEventPageBlockFailure({ error }));
          }));
      })
    );
  });

  removeEventPageBlock$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.removeEventPageBlock),
      exhaustMap(({ payload }) => {
        return this.eventService.removeEventPageBlock(payload).pipe(
          map(data => {
              return EventActions.removeEventPageBlockSuccess({ data });
          }),
          catchError(error => {
            return of(EventActions.removeEventPageBlockFailure({ error }));
          }));
      })
    );
  });

  updateEventConfigPage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.updateEventConfigPage),
      exhaustMap(({ payload }) => {
        return this.eventService.updateEventConfigPage(payload).pipe(
          map(data => {
            return EventActions.updateEventConfigPageSuccess({ data });
          }),
          catchError(error => {
            return of(EventActions.updateEventConfigPageFailure({ error }));
          }));
      })
    );
  });

  addToCart$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.addToCart),
      exhaustMap(({ payload }) => {
        return this.eventService.addToCart(payload).pipe(
          map(data => {
            return EventActions.addToCartSuccess({ data });
          }),
          catchError(error => {
            return of(EventActions.addToCartFailure({ error }));
          }));
      })
    );
  });

  addRegistration$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.addRegistration),
      exhaustMap(({ payload }) => {
        return this.eventService.addRegistration(payload).pipe(
          map(data => {
            return EventActions.addRegistrationSuccess({ data });
          }),
          catchError(error => {
            return of(EventActions.addRegistrationFailure({ error }));
          }));
      })
    );
  });

  removeRegistration$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.removeRegistration),
      exhaustMap(({ payload }) => {
        return this.eventService.removeRegistration(payload).pipe(
          map(data => {
            return EventActions.removeRegistrationSuccess({ data });
          }),
          catchError(error => {
            return of(EventActions.removeRegistrationFailure({ error }));
          }));
      })
    );
  });

  updateRegistration$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.updateRegistration),
      exhaustMap(({ payload }) => {
        return this.eventService.updateRegistration(payload).pipe(
          map(data => {
            return EventActions.updateRegistrationSuccess({ data });
          }),
          catchError(error => {
            return of(EventActions.updateRegistrationFailure({ error }));
          }));
      })
    );
  });

  createStream$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.createStream),
      exhaustMap(({ payload }: any) => {
        return this.eventService.createStream(payload).pipe(
          map(data => {
            return EventActions.createStreamSuccess({ data });
          }),
          catchError(error => of(EventActions.createStreamFailure({ error }))))
      })
    );
  });

  loadAllStreams$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.loadAllStreams),
      exhaustMap((action: any) => {
        return this.eventService.getAllStreams().pipe(
          map(data => EventActions.loadAllStreamsSuccess({ data })),
          catchError(error => of(EventActions.loadAllStreamsFailure({ error }))))
      })
    );
  });

  loadVideoDownloadUrl$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.loadVideoDownloadUrl),
      exhaustMap(({ payload }) => {
        return this.eventService.getVideoDownloadUrl(payload).pipe(
          map(data => EventActions.loadVideoDownloadUrlSuccess({ data, payload })),
          catchError(error => of(EventActions.loadVideoDownloadUrlFailure({ error }))))
      })
    );
  });

  eventRedirectToListAction$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventActions.EventRedirectToListAction),
      exhaustMap(() => this.router.navigateByUrl("/event/list"))
    );
  }, { dispatch: false })

  constructor(
    private actions$: Actions,
    private loadingService: LoadingService,
    private eventService: EventService,
    private router: Router
  ) {}

}

